import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=7f638a28&scoped=true&"
import script from "./PageDetail.vue?vue&type=script&lang=js&"
export * from "./PageDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageDetail.vue?vue&type=style&index=0&id=7f638a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f638a28",
  null
  
)

export default component.exports